import { ACCOUNT_ROUTES, CTL_ROUTES } from '../../navigation/paths';

export const VATIKA_LOGO_WIDTH = 50;
export const HEADER_LOGO_WIDTH = 110;
export const HEADER_LOGO_MAX_HEIGHT = { xs: 45, md: 50 } as const;
export const HEADER_USER_NAME_MAX_WIDTH = 160;

export const SIDEBAR_DRAWER_WIDTH = 240;

export const PROFILE_MENU_ID = 'account-profile-menu';

export const PROFILE_MENU_ROUTES = {
  profile: ACCOUNT_ROUTES.contact,
  notifications: CTL_ROUTES.settings,
  recent: CTL_ROUTES.recent,
  checkin: '/checkIn',
  attendance: '/checkInForRO',
  about: '/aboutPage',
} as const;
